export enum ACCESS_RIGHTS {
  OWNER = 'OWNER',
  ADMIN = 'ADMIN',
  AGENT = 'AGENT',
  MANAGER = "MANAGER"
}

export enum GENDER {
  MALE = 'MALE',
  FEMALE = 'FEMALE'
  // OTHER = 'OTHER',
  // UNSPECIFIED = 'UNSPECIFIED'
}

export enum ID_TYPES {
  GHANA_CARD = 'GHANA_CARD',
  PASSPORT = 'PASSPORT',
  VOTER_ID = 'VOTER_ID',
  DRIVER_LICENSE = 'DRIVER_LICENSE',
  SOCIAL_SECURITY = 'SOCIAL_SECURITY'
}

export enum PAYMENT_STATUS_STATES {
  INITIALIZING = "INITIALIZING", // Payment initialized
  PENDING = "PENDING", //Created locally
  PROCESSING = "PROCESSING", //Customer has been redirected to Paystack
  CREATED = 'CREATED',
  SUCCESS = 'SUCCESS',
  REJECTED = 'REJECTED',
  FAILED = "FAILED",
}

export enum ToastType {
  SUCCESS = 'success',
  INFO = 'info',
  ERROR = 'error',
  WARNING = 'warning',
  DEFAULT = 'default'
}

export enum UPLOADABLE_DOCUMENT_TYPES {
  DRIVER_LICENSE_FRONT = 'DRIVER_LICENSE_FRONT',
  DRIVER_LICENSE_BACK = 'DRIVER_LICENSE_BACK',
  ID_CARD = 'ID_CARD',
  STAFF_ID = 'STAFF_ID',
  PAYSLIP = 'PAYSLIP',
  OTHER = 'OTHER',
  INSURANCE_STICKER = 'INSURANCE_STICKER',
  INSURANCE_CERTIFICATE = 'INSURANCE_CERTIFICATE',
  CONTRACT_SUMMARY = 'CONTRACT_SUMMARY',
  PAYMENT_AGREEMENT = 'PAYMENT_AGREEMENT',
  PASSPORT_PHOTO = 'PASSPORT_PHOTO',
  POLICY_STICKER = 'POLICY_STICKER',
  ROADWORTHY_CERTIFICATE = 'ROADWORTHY_CERTIFICATE',
  ROADWORTHY = 'ROADWORTHY',
  RENEWAL_NOTICE = ' RENEWAL_NOTICE',
  VEHICLE_PHOTO_FRONT = 'VEHICLE_PHOTO_FRONT',
  VEHICLE_PHOTO_BACK = 'VEHICLE_PHOTO_BACK',
  VEHICLE_PHOTO_LEFT = 'VEHICLE_PHOTO_LEFT',
  VEHICLE_PHOTO_RIGHT = 'VEHICLE_PHOTO_RIGHT'
}

export enum UPLOAD_IMAGE_ENDPOINTS {
  CUSTOMER = '/admin/document/customer/upload',
  VEHICLE = '/admin/document/vehicle/upload',
  POLICY = '/admin/document/policy/upload',
  STAFF = '/admin/staff/account/photo',
  INSURER_LOGO = "/admin/insurers/upload/logo",
  INSUER_STORE_BANNER = "/admin/insurers/upload/banner"
}

export enum MOBILE_MONEY_NETWORKS {
  MTN = 'MTN',
  VODAFONE = 'VODAFONE'
  // AIRTEL = "AIRTEL"
}

export enum CURRENCIES {
  USD = 'USD',
  GHS = 'GHS',
  EUR = 'EUR'
}

export enum COMMUNITY_TYPES {
  UNION = 'UNION',
  ASSOCIATION = 'ASSOCIATION',
  SCHOOL = 'SCHOOL',
  CHURCH = 'CHURCH',
  COMPANY = 'COMPANY',
  OTHER = 'OTHER'
}

export enum COMMUNITY_CHANNEL_OPTIONS {
  EMAIL = 'EMAIL',
  PUSH = 'PUSH',
  SMS = 'SMS'
}

export enum DOWNLOAD_FILE_TYPES {
  CSV = "CSV",
  PDF = "PDF",
  VIEW = "VIEW",
  // VIDEO = "VIDEO",
}

export enum REDACT_INFO_TYPES {
  EMAIL = "EMAIL",
  PHONE = "PHONE"
}

export enum TRANSACTION_TYPES {
  CREDIT = "CREDIT",
  DEBIT = "DEBIT"
}

export enum ACCOUNT_TYPES {
  SUSU = "SUSU",
  SAVINGS = "SAVINGS",
  INVESTMENT = "INVESTMENT",
  FIXED = "FIXED",
  KIDI_ACCOUNT = "KIDI_ACCOUNT"
}

export enum CUSTOMER_TYPES {
  PERSONAL = "PERSONAL",
  JOINT = "JOINT",
  CORPORATE = "CORPORATE",
}

export enum BUSINESS_TYPE {
  COMPANY = "COMPANY",
  ASSOCIATION = "ASSOCIATION",
  SCHOOL = "SCHOOL",
  NGO = "NGO"
}

export enum MARITAL_STATUS {
  SINGLE = "SINGLE",
  MARRIED = "MARRIED",
  DIVORCED = "DIVORCED",
  WIDOWED = "WIDOWED"
}

export enum NATIONALITIES {
  GHANAIAN = "GHANAIAN"
}

export enum ENVIRONMENTS {
  PRODUCTION = "production",
  DEVELOPMENT = "development",
  STAGING = "staging",
  DEV = "dev"
}

export enum DELETE_IMAGE_ENDPOINTS {
  INSURER_LOGO = '/admin/insurers/insurer/logo',
  INSURER_BANNER = '/admin/insurers/insurer/banner'
}

export enum STATEMENT_FORMAT {
  VIEW = "view",
  PDF = "pdf",
  EXCEL = "excel"
}

export enum COMPANY_TYPES {
  INTERNAL = "INTERNAL",
  SUSU = "SUSU",
  MICROFINANCE = "MICROFINANCE"
}

export enum PAYMENT_CYCLES {
  DAILY = "DAILY",
  WEEKLY = "WEEKLY",
  MONTHLY = "MONTHLY",
  ANNUALLY = "ANNUALLY",
}

export enum PAYMENT_MODES {
  CASH = 'CASH',
  MOBILE_MONEY = "MOBILE_MONEY",
  BANK_TRANSFER = "BANK_TRANSFER",
  CHEQUE = 'CHEQUE',
  CARD = "CARD"
}

export enum ONLINE_PAYMENT_MODES {
  MOBILE_MONEY = "MOBILE_MONEY",
  BANK_TRANSFER = "BANK_TRANSFER",
  CARD = "CARD"
}

export enum CUSTOMER_RELATIONSHIP_TYPES {
  PRIMARY = "PRIMARY",
  OWNER = "OWNER",
  MEMBER = "MEMBER",
  DIRECTOR = "DIRECTOR",
  SIGNATORY = "SIGNATORY",
  NEXT_OF_KIN = "NEXT_OF_KIN"
}

export enum DATA_PERIODS {
  TODAY = "TODAY",
  YESTERDAY = "YESTERDAY",
  THIS_WEEK = "THIS_WEEK",
  THIS_MONTH = "THIS_MONTH"
}

export enum DATE_RANGE_TYPES {
  YEAR_TO_DATE = "year-to-date",
  TODAY = "today",
  YESTERDAY = "yesterday",
  LAST_7_DAYS = "last-7-days",
  THIS_WEEK = "this-week",
  THIS_MONTH = "this-month",
  LAST_MONTH = "last-month",
  LAST_YEAR = "last-year",
  CUSTOM_DATE = "custom",
}

export enum RECONCILIATION_STAGES {
  PENDING = "PENDING",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
  CANCELLED = "CANCELLED"
}

export enum STATUS_OPTIONS {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  PENDING = "PENDING",
  APPROVED = "APPROVED",
  CANCELLED = "CANCELLED",
  REJECTED = "REJECTED"
}

export enum FEE_RATE_TYPES {
  PERCENTAGE = "PERCENTAGE",
  FIXED = "FIXED"
}

export enum INTEREST_CALCULATION_METHODS {
  FLAT = "FLAT",
  REDUCING_BALANCE = "REDUCING_BALANCE"
}

export enum FINANCING_REPAYMENT_FREQUENCIES {
  DAILY = "DAILY",
  WEEKLY = "WEEKLY",
  BI_WEEKLY = "BI_WEEKLY",
  MONTHLY = "MONTHLY",
  QUARTERLY = "QUARTERLY",
}

export enum APPLICATION_STAGES {
  PENDING = "PENDING",
  APPROVED = "APPROVED",
  DISBURSED = "DISBURSED",
  REJECTED = "REJECTED",
  CANCELLED = "CANCELLED",
}

export enum LOAN_STATUSES {
  IN_ACTIVE = "IN_ACTIVE",
  ACTIVE = "ACTIVE",
  SETTLED = "SETTLED",
  WRITTEN_OFF = "WRITTEN_OFF"
}

export enum LOANK_RISK_STATUS {
  CURRENT = "CURRENT",
  OVERDUE = "OVERDUE",
  DEFAULTED = "DEFAULTED"
}

export enum FINANCING_SCHEDULE_STATUS {
  PENDING = "PENDING",
  PARTIALLY_PAID = "PARTIALLY_PAID",
  PAID = "PAID",
  OVERDUE = "OVERDUE"
}

export enum INTEREST_PERIOD {
  DAILY = "DAILY",
  WEEKLY = "WEEKLY",
  MONTHLY = "MONTHLY",
  QUARTERLY = "QUARTERLY",
  ANNUALLY = "ANNUALLY",
}

export enum PASSBOOK_SALE_REASON_ENUM {
  NEW = "NEW",
  LOST = "LOST",
  FULL = "FULL",
  OTHER = "OTHER"
}

export enum PASSBOOK_STATUS {
  ACTIVE = "ACTIVE",
  REPLACED = "REPLACED",
  VOID = "VOID",
  LOST = "LOST"
}

export enum REVENUE_TYPE {
  SUSU_COMMISSION = "SUSU_COMMISSION",
  LOAN_INTEREST = "LOAN_INTEREST",
  LOAN_PROCESSING_FEE = "LOAN_PROCESSING_FEE",
  LATE_PAYMENT_FEE = "LATE_PAYMENT_FEE",
  PASSBOOK_SALE = "PASSBOOK_SALE",
  ACCOUNT_OPENING_FEE = "ACCOUNT_OPENING_FEE",
  REGISTRATION_FEE = "REGISTRATION_FEE",
  TRANSFER_FEE = "TRANSFER_FEE"
}

export enum SUSU_CYCLE_STATUS {
  IN_ACTIVE = "IN_ACTIVE",
  ACTIVE = "ACTIVE",
  COMPLETED = "COMPLETED",
  WITHDRAWN = "WITHDRAWN",
  PARTIALLY_WITHDRAWN = "PARTIALLY_WITHDRAWN"
}

export enum AGENT_TARGET_PERIOD {
  JAN = "JAN",
  FEB = "FEB",
  MAR = "MAR",
  APR = "APR",
  MAY = "MAY",
  JUN = "JUN",
  JUL = "JUL",
  AUG = "AUG",
  SEP = "SEP",
  OCT = "OCT",
  NOV = "NOV",
  DEC = "DEC",
}

export enum RANK_AGENTS_BY {
  DEPOSIT_COUNT = "DEPOSIT_COUNT",
  DEPOSIT_AMOUNT = "DEPOSIT_AMOUNT",
  CUSTOMER_COUNT = "CUSTOMER_COUNT"
}

export enum AGENT_ACHIEVEMENT_STATUS {
  EXCEEDED = "Exceeded",
  ACHIEVED = "Achieved",
  ON_TRACK = "On Track",
  BEHIND = "Behind",
  CATCHING_UP = "Catching Up"
}

export enum PAYMENT_SERVICES {
  PAYSTACK = "PAYSTACK",
  HUBTEL = "HUBTEL",
}

export enum COMPANY_EXPENSE_TYPE {
  SMS_CREDIT = "SMS_CREDIT",
  EMAIL_CREDIT = "EMAIL_CREDIT",
  WHATSAPP_CREDIT = "WHATSAPP_CREDIT",
  BILLING = "BILLING",
  OTHER = "OTHER"
}

export enum DASHBOARD_BANNER_TYPE {
  SUBSCRIPTION = "SUBSCRIPTION",
  SMS_CREDIT = "SMS_CREDIT"
}

export enum COMPANY_PAYMENT_REFERENCE_TYPE {
  COMPANY_PAYMENT = "App\Models\CompanyPayment",
  SMS_NOTIFICATION = "App\Models\SmsNotification"
}

export enum COMPANY_CREDIT_TYPES {
  SMS = "SMS",
  EMAIL = "EMAIL",
  WHATSAPP = "WHATSAPP",
  OTHER = "OTHER",
}

export enum PAYABLES {
  ACCOUNT = "ACCOUNT",
  TRANSACTION = "TRANSACTION",
  COMPANY_CREDIT = "COMPANY_CREDIT",
  LOAN = "LOAN",
  BILLING = "BILLING"
}

export enum REPORT_TYPES {
  DEPOSITS_PORTFOLIO = "DEPOSITS_PORTFOLIO",
  TOP_LARGEST_DEPOSITORS = "TOP_LARGEST_DEPOSITORS"
}

export enum REFERENCE_TYPES {
  COMPANY_PAYMENT = "App\Models\CompanyPayment", //Credits purchased
  SMS_NOTIFICATION = "App\Models\SmsNotification", //Sms
  ACCOUNT = "App\Models\Account",
  TRANSACTION = "App\Models\Transaction",
  CUSTOMER = "App\Models\Customer",
  LOAN = "App\Models\Loan"
}

export enum MODEL_TYPES {
  ACCOUNT = "ACCOUNT",
  TRANSACTION = "TRANSACTION",
  COMPANY_CREDIT = "COMPANY_CREDIT",
  LOAN = "LOAN",
  BILLING = "BILLING",
  CUSTOMER = "CUSTOMER"
}

export enum SCREEN_MODES {
  DARK = "DARK",
  LIGHT = "LIGHT"
}

export enum PRODUCT_CATEGORIES {
  ELECTRONICS = "ELECTRONICS",
  HEALTH_AND_BEAUTY = "HEALTH_AND_BEAUTY",
  HOME_AND_GARDEN = "HOME_AND_GARDEN",
  SPORTS_AND_LEISURE = "SPORTS_AND_LEISURE"
}

export enum FINANCING_TYPES {
  LOAN = "LOAN",
  HIRE_PURCHASE = "HIRE_PURCHASE"
}
